import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {UserAuthService} from './user-auth.service';
import {ServerAuthService, UserLoginModel} from './server-auth.service';
import { AngularFireAuth }  from '@angular/fire/compat/auth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/database';

@Injectable({
  providedIn: 'root'
})
export class SigninStrategyService {
  firebaseAuth = firebase.auth;
  returnUrl?: string;

  constructor(
    private router: Router,
    private userAuthSvc: UserAuthService,
    private serverAuthSvc: ServerAuthService,
    private afAuth: AngularFireAuth,
/*     private toastr: ToastrManager */ 
 ) {
  }

  // local(params: LoginParams) {
  //   this.returnUrl = params.returnUrl;
  //   this
  //     .serverAuthSvc
  //     .signinLocal(params.email, params.password)
  //     .subscribe(this.saveLoginAndNavigateToReturnUrl, this.logError);
  // }
  private signinWithProvider = (provider:any): Promise<any> => {
    provider.setCustomParameters({
      state: '345'
    });
    console.log('signinWithProvider', provider);
    return this.afAuth
      .signInWithRedirect(provider);
  };

  signInFacebook(returnUrl: string) {
    this.returnUrl = returnUrl;
   return this.signinWithProvider(new this.firebaseAuth.FacebookAuthProvider());
  }

  signInTwitter(returnUrl: string) {
    this.returnUrl = returnUrl;
   return this.signinWithProvider(new this.firebaseAuth.TwitterAuthProvider());
  }

  signInGoogle(returnUrl: string) {
    this.returnUrl = returnUrl;
    console.log('signinGoogle', this.returnUrl);
    const provider = new this.firebaseAuth.GoogleAuthProvider();
    provider.addScope('profile');
    provider.addScope('email');
    return this.signinWithProvider(provider);
  }

  createFirebaseUser(creds: { email: string, password: string, username: string, returnUrl: string }) {
    this.returnUrl = creds.returnUrl;
    firebase
    .auth()
    .createUserWithEmailAndPassword(creds.email, creds.password)
    .then(user => {
      firebase?.auth()?.currentUser?.updateProfile({displayName: creds.username, photoURL: ''});

      })
      .catch(this.logError);
    this.retrieveIdTokenAndExchangeToken();
  }

  signInFirebaseUserWithCreds(creds: { email: string, password: string, returnUrl: string }) {
    this.returnUrl = creds.returnUrl;
    firebase
      .auth()
      .signInWithEmailAndPassword(creds.email, creds.password)
      .catch(this.logError);
    this.retrieveIdTokenAndExchangeToken();
  }

  /* private signinWithProvider = (provider:any): Promise<any> => {
    console.log('signinWithProvider', provider);
    return this.afAuth
      .signInWithPopup(provider)
      .then((res:any) => {
          this.retrieveIdTokenAndExchangeToken().then((r) => {
            return r;
          });
          return this.retrieveIdTokenAndExchangeToken();
        }, (err:any) => this.logError(err)
      );
  }; */

  async AuthLogin() {
    const provider = new this.firebaseAuth.GoogleAuthProvider();
    provider.addScope('profile');
    provider.addScope('email');
    
    console.log('signinWithProvider', provider);
    try {
      const result: firebase.auth.UserCredential = await this.afAuth
        .signInWithPopup(provider);
        console.log('result', result);
      if (result) {
        const credential = result.user!;
        const token = await credential.getIdTokenResult(true);
        console.log('token', token);
        return token;
      } else {
        return console.log('');
      }
    } catch (error) {
      window.alert(error);
    }
  }

  private getFirebaseUserIdToken = async () => {
    // return firebase
    //   .auth()
    //   .currentUser
    //   .getIdToken(true);
    const provider = new this.firebaseAuth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
    const result: firebase.auth.UserCredential = await this.afAuth
        .signInWithPopup(provider);
      if (result) {
        const credential = result.user!;
        const token = await credential.getIdTokenResult(true);
        return token;
      } else {
        return console.log('');
      }
  };

  private retrieveIdTokenAndExchangeToken = (): Promise<any> => {
    return this
      .getFirebaseUserIdToken()
      .then((idToken:any) => {
        return this
          .serverAuthSvc
          .signinFirebase(idToken);
        // .subscribe(this.saveLoginAndNavigateToReturnUrl, this.logError);
        // .subscribe((result) => {
        //   console.log('userinfo', result);
        //   return result;
        // }, this.logError);
      });
  };

  saveLoginAndNavigateToReturnUrl = (loginModel: UserLoginModel) => {
    this.userAuthSvc.signIn(loginModel);
    window.location.href = this.returnUrl!;
  };

  private logError = (err:any) => {
    console.log(err);
    //this.toastr.errorToastr('Login Error', err);
  };
}


export interface LoginParams {
  email: string;
  password: string;
  returnUrl: string;
}
